import React, { useState, useEffect } from "react";
// import { ThemeProvider } from "@mui/material/styles";
// import { Input } from "mdb-ui-kit"; // module
import "mdb-ui-kit/css/mdb.min.css";

import "../Branches/Styles/BranchForm.css";
import axios from "axios";
import ApiSettings from "../../../../../Settings/ApiSettings.json";

import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Cookies from "universal-cookie";
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel,TextField,Typography } from "@mui/material";
import { type } from "@testing-library/user-event/dist/type";
const cookies = new Cookies();
// export interface State extends SnackbarOrigin {
//   open: boolean;
// }
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function StageTransactionTypeForm(props) {
  const [StagesSelected, setStagesSelected] = useState([]);
  // const []=useState([]);
  const [object, setObject] = useState({
    name: props.object.name,
    id: props.object.id,
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!cookies.get("role_id")) {
      window.location.href = "/";
    }
  }, []);

  const [stages, setStages] = useState([]);
  

  //   const [openSnackbar, setopenSnackbar] = useState(false);
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });
  const { vertical, horizontal, open } = snackBar;

  //get data of varieties Carrier ....
  const getDataOfStages= async (IpAddress) => {
    let data = null;
    try {
      data = await axios({
        method: "get",
        url: IpAddress + "/stages_list",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-localization": 'ar'
        },
      });

      if (data) {
        if (data.status == 200) {
          setStages(data.data);
        }
      }
    } catch (err) {
      //   alert(err.message);
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "warning",
        open: true,
      });
    }
  };

  // get data relation between stage and transaction type
  const getDataOfStageTransactionType=async()=>{
    let data=null;
    try{
     data=await axios({
      method: "GET",
      url: ApiSettings.apiUrl+"/stage_transaction_types/"+props.object.id,
      headers: { 
        "Content-Type": "application/json",
        'Accept': 'application/json',
      }
     })
     if(data){
        if(data.data.status==200){
         if(data?.data?.data&&data?.data?.data.length>0){
            data?.data?.data.map((data)=>{
                setStagesSelected((item)=>[...item,{
                  stages_id:data.stage_id,
                  order:data.order_number
                }])
            })
         }

        }else if(data.data.status==500){
          setsnackBar({
            ...snackBar,
            message: data.data.data?.id,
            severity: "warning",
            open: true,
          });
        }else{
          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "warning",
            open: true,
          });
        }
     }
    }
    catch(err){
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "error",
        open: true,
      });
    }
  }

  useEffect(() => {
    getDataOfStages(ApiSettings.apiUrl);
    getDataOfStageTransactionType(ApiSettings.apiUrl);
  }, [props.object]);

  //here we will sent request with data to save it in our database.
  const sentFormData = async () => {

    if (!object.name) {
      //   alert("أسم الفرع مطلوب");
      setsnackBar({
        ...snackBar,
        message: "أسم الفرع مطلوب",
        severity: "warning",
        open: true,
      });
      return;
    }

    setLoading(true);
    let formData=new FormData();
    formData.append('transaction_type_id',object.id);
    StagesSelected.map((data,index)=>{
      formData.append(`stages[${index}][stages_id]`,data.stages_id);
      formData.append(`stages[${index}][order]`,data.order);

    })


    let data = null;
    try {
      data = await axios({
        method: "post",
        url: ApiSettings.apiUrl + "/stage_transaction_types",
        data:formData,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-localization": 'ar'
        },
      });

      console.log("update", data);
      if (data) {
        if (data.data.status == 200) {
          setLoading(false);

          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "success",
            open: true,
          });
          // props.setReloadData()
        } else if (data.data.status == 402) {
          //   alert(data.data.data.name);
          setsnackBar({
            ...snackBar,
            message: data.data.data.name,
            severity: "warning",
            open: true,
          });
        } else {
          //   alert(data.data.message);
          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "warning",
            open: true,
          });
        }
        setLoading(false);
      }
    } catch (err) {
      //   alert(err.message);
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "error",
        open: true,
      });
      setLoading(false);
    }
  };

  //handle open snackbar ....
  const handleClick = () => {
    setsnackBar({ open: true, ...snackBar });
  };
  //handle clode snackbar
  const handleClose = () => {
    setsnackBar({ ...snackBar, open: false });
  };

  const handleInputChange = (event, stages_id) => {
    const target = event.target;
    // console.log("ischecked",target.checked);
    if (target.checked) {
      setStagesSelected([...StagesSelected, {
        order:null,
        stages_id:stages_id
      }])
    }
    else {
      const stagesSelectedlist = StagesSelected.filter(function (item) {
        return item.stages_id !== stages_id
      })
      setStagesSelected(stagesSelectedlist)
    }

  };

  const handleInputChangeOrder=(stage,order)=>{
    let getStages_check=false;
     let arr=[];
        StagesSelected.map((data)=>{
            if(data.stages_id==stage.stages_id){
              // getStages_check=true;
              arr.push({
                order:order,
                stages_id:stage.stages_id
              })
            }else{
              arr.push({
                order:data.order,
                stages_id:data.stages_id
              })
            }
        })

      setStagesSelected(arr)
  
  }

  const getExistsStagesSelected=(stage)=>{
    let check_stage=false;
    StagesSelected.map((data)=>{
        if(data.stages_id==stage.id){
          check_stage=true;
        }
    })
    return check_stage;
  }


  return (
    <div
      className={`ModalFormContainer rounded-3 px-2 ${props.inactive === false ? "activeSideMenu" : ""
        }`}
        style={{height:'90%'}}
    >
      {/* header of form section  */}
      <div className="container-lg py-4 px-2 ">
        <div className="row">
          <div className="col-md-12 ">
            <div className="toSection d-flex justify-content-center align-items-center">
              <span className="FormName">مراحل الادخال لمعاملة  {object.name}</span>
            </div>
          </div>
        </div>
      </div>

      {/* section1 here...  */}
      <div className="section1 container-lg py-4 px-2 pe-4">
        <div className="row">
          <div className="col-md-12 align-items-center  d-flex " style={{
            flexDirection: 'column',
            borderStyle: 'solid',
            borderColor: 'rgb(95, 123, 138)',
            borderWidth: '2px',
            borderRadius: '10px',
            paddingTop: '10px',
            paddingBottom: '10px'
          }}>
            
            <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
              <FormLabel component="legend">اختر من مراحل الادخال الاتية</FormLabel>
              <FormGroup>
              {stages.map((stage) => {
                var isChecked = false;
             
                if (StagesSelected.length > 0 && getExistsStagesSelected(stage)) {
                  isChecked = true;
                }
                return(<div style={{
                      display: "flex",
                      flexDirection: "row",
                      flexFlow: "row wrap",
                       
                      // border: "1px solid",
                      borderColor: "#5f7b8a",
                      borderRadius: 10,
                      margin: "0 10px",
                      padding:"0 10px", 
                      paddingBottom: 10,
                  }}>
                     <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "50%",
                          minWidth: 200,
                          marginTop: 10,
                          paddingTop: 10,
                          paddingLeft: 10,
                          // paddingRight: 10,
                          justifyContent: "start",
                          alignItems: "center",
                        }}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox checked={isChecked} onChange={(e) => handleInputChange(e, stage.id)} name="gilad" />
                          }
                          label={stage.name}
                        />
                  </div>
                  {
                    StagesSelected.map((data)=>(
                       data.stages_id==stage.id ?
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          // width: "50%",
                          flex: 1,

                          minWidth: 200,
                          marginTop: 10,
                          paddingTop: 10,
                          paddingLeft: 10,
                          paddingRight: 10,
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <FormControl fullWidth>
                          <TextField
                            label="رقم الترتيب"
                            variant="outlined"
                            disabled={!isChecked}
                            value={data.order}
                            type="number"
                             onChange={(e)=>{
                                handleInputChangeOrder(data,e.target.value);
                             }}
                  
                          />
                        </FormControl>
                        <Typography className="fontForError">
                        
                        </Typography>
                      </div>:null
                    ))
                  }

                {
                   getExistsStagesSelected(stage)==false?
                   <div
                   style={{
                     display: "flex",
                     flexDirection: "column",
                     // width: "50%",
                     flex: 1,

                     minWidth: 200,
                     marginTop: 10,
                     paddingTop: 10,
                     paddingLeft: 10,
                     paddingRight: 10,
                     justifyContent: "center",
                     alignItems: "center",
                   }}
                 >
                   <FormControl fullWidth>
                     <TextField
                       label="رقم الترتيب"
                       variant="outlined"
                       disabled={true}
                       type="number"
                        onChange={(e)=>{
                           // handleInputChangeOrder(data,e.target.value);
                        }}
             
                     />
                   </FormControl>
                   <Typography className="fontForError">
                   
                   </Typography>
                    </div>
                   :null
                }
                   
                 
                </div>)
              })}
                
              </FormGroup>
              <FormHelperText>تستطيع اختيار اكثر من واحدة</FormHelperText>
            </FormControl>




            <Button
              variant="contained"
              className="mx-3 section1CarrerName section1Button mt-4 pt-1"
              onClick={() => {
                sentFormData();
              }}
            >
              {!loading ? (
                "تحديث"
              ) : (
                <div className="spinner-border " role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </Button>

          </div>
        </div>
      </div>
      {/* snack alert box here ... */}
      <Snackbar
        open={snackBar.open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          onClose={handleClose}
          severity={snackBar.severity}
          sx={{ width: "100%" }}
        >
          {snackBar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
